import useTranlate from '@hooks/useTranslate';

export interface TranslateProps {
  children: string;
}

export const Translate: React.FC<TranslateProps> = ({ children }) => {
  const translate = useTranlate();
  // i18n-extract-disable
  return <>{translate(children)}</>;
};

export default Translate;
